itsoftApp.createModule("utekaInit", function () {
    var module = this;

    window.isLoadedUtekasProducts = false;

    var utekaInit = function () {
        window.uteka = {
            /**
             * Функция для инициализации виджета
             *
             * @param {HTMLElement} widget – DOM элемент виджета
             * @param {object} options
             * @param {string} options.productId – ID выбранного товара (опционально)
             * @param {string[]} options.productIds – ID товаров для выбора через селектор товаров (опционально)
             * @param {string} options.utmTerm – UTM term (опционально)
             * @param {string} options.utmSource – UTM source (опционально)
             * @param {string} options.utmMedium – UTM medium (опционально)
             * @param {string} options.utmContent – UTM content (опционально)
             * @param {string} options.utmCampaign – UTM campaign (опционально)
             */
            
            _host: 'widget.uteka.ru',
            _queue: [],
            _loaded: false,
            loadWidgetPre: function (widget, options) {
                if (
                    !options.productId &&
                    !options.productIds
                ) {
                    throw new TypeError("Для загрузки виджета необходимо передать параметр 'productId' или 'productIds'");
                }

                if (
                    options.productId &&
                    options.productIds &&
                    options.productIds.length > 0 &&
                    options.productIds.indexOf(options.productId) === -1
                ) {
                    throw new TypeError("Параметр 'productIds' должен в себя включать ID товара, переданный через параметр 'productId'");
                }

                // var iframe = widget.querySelector("iframe");
                var query = [];

                if (options.productIds) {
                    options.productIds.forEach(function (productId) {
                        query.push("productIds=" + productId);
                    });
                }
                if (options.productId) {
                    query.push("productId=" + options.productId);
                }
                if (options.utmTerm) {
                    query.push("utm_term=" + options.utmTerm);
                }
                if (options.utmSource) {
                    query.push("utm_source=" + options.utmSource);
                }
                if (options.utmMedium) {
                    query.push("utm_medium=" + options.utmMedium);
                }
                if (options.utmContent) {
                    query.push("utm_content=" + options.utmContent);
                }
                if (options.utmCampaign) {
                    query.push("utm_campaign=" + options.utmCampaign);
                }

                var src = 'https://' + window.uteka._host + '/static/widgets/widget.compiled.js?l=' + Date.now()
                itsoftApp.loadScript(src, function () {
                    window.uteka.loadWidget(widget, options)
                });

                // var script = document.createElement('script');
                //   script.src = src;
                //   script.addEventListener('load', function () {
                //     window.uteka._loaded = true
                    
                //   })

                //   document.body.appendChild(script)

                // src += "?" + query.join("&");
            },
        };
    };

    utekaInit();

    module.callback = utekaInit;
});